import ForgotPassword from "components/ForgotPassword/ForgotPassword";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { AdyenRoutesName } from "./route-names";
import { getRoutePath } from "./route-utils";
import { PrivateRoute } from "./PrivateRoute";
import { AuthenticatedLayout } from "components/Layout/AuthenticatedLayout";
import FirstMarketplace from "pages/FirstMarketplace/FirstMarketplace";
import Marketplaces from "pages/Marketplaces/Marketplaces";
import Reports from "pages/Reports/Reports";
import HOP from "pages/HOP/HOP";
import { GuestLayout } from "components/Layout/GuestLayout";
import LoginForm from "components/LoginForm/LoginForm";
import { ShopInvoiceLogs } from "pages/Logs/MarketplaceLogs/ShopInvoice";
import { ResetPassword } from "components/ResetPassword/ResetPassword";
import { Boarding } from "pages/Boarding/Boarding";
import MarketplaceControl from "pages/MarketplaceControl/MarketplaceControl";
import AdyenUsers from "pages/Users/AdyenUsers";
import HOPAuth from "pages/HOPAuth/HOPAuth";
import LoginMirakl from "components/LoginMirakl/LoginMirakl";

export const AppRouter = () => {
  return (
    <BrowserRouter>
      <div className="App">
        <Routes>
          {/* Unauthenticated routes */}
          <Route
            path={getRoutePath(AdyenRoutesName.LOGIN)}
            element={
              <GuestLayout>
                <LoginForm />
              </GuestLayout>
            }
          />
          <Route
            path={getRoutePath(AdyenRoutesName.FORGOT_PASSWORD)}
            element={
              <GuestLayout>
                <ForgotPassword />
              </GuestLayout>
            }
          />
          <Route
            path={getRoutePath(AdyenRoutesName.LOGIN_WITH_MIRAKL)}
            element={
              <GuestLayout>
                <LoginMirakl />
              </GuestLayout>
            }
          />
          <Route
            path={getRoutePath(AdyenRoutesName.RESET_PASSWORD)}
            element={
              <GuestLayout>
                <ResetPassword />
              </GuestLayout>
            }
          />
          <Route
            path={getRoutePath(AdyenRoutesName.BOARDING_TUTORIAL)}
            element={<Boarding />}
          />
          <Route path={getRoutePath(AdyenRoutesName.HOP_AUTH)} element={<HOPAuth />} />
          <Route path={getRoutePath(AdyenRoutesName.HOP)} element={<HOP />} />
          {/* Authenticated routes */}
          <Route
            path="*"
            element={
              <AuthenticatedLayout>
                <PrivateRoute>
                  <Route
                    path={getRoutePath(AdyenRoutesName.DASHBOARD_MARKETPLACES)}
                    element={<Marketplaces />}
                  />
                  <Route
                    path={getRoutePath(AdyenRoutesName.DASHBOARD_REPORTS)}
                    element={<Reports />}
                  />

                  <Route
                    path={getRoutePath(AdyenRoutesName.DASHBOARD_USERS)}
                    element={<AdyenUsers />}
                  />
                  <Route
                    path={getRoutePath(AdyenRoutesName.DASHBOARD_LOGS)}
                    element={<div />}
                  />
                  <Route
                    path={getRoutePath(AdyenRoutesName.MARKETPLACE_LOGS)}
                    element={<ShopInvoiceLogs />}
                  />

                  <Route
                    path={getRoutePath(
                      AdyenRoutesName.DASHBOARD_FIRST_MARKETPLACE
                    )}
                    element={<FirstMarketplace />}
                  />
                  <Route
                    path={getRoutePath(AdyenRoutesName.EDIT_MARKETPLACE)}
                    element={<FirstMarketplace />}
                  />
                  <Route
                    path={getRoutePath(AdyenRoutesName.MARKETPLACE_CONTROL)}
                    element={<MarketplaceControl />}
                  />
                  {/* default redirection to home page */}
                  <Route
                    path="*"
                    element={
                      <Navigate
                        to={getRoutePath(
                          AdyenRoutesName.DASHBOARD_MARKETPLACES
                        )}
                      />
                    }
                  />
                </PrivateRoute>
              </AuthenticatedLayout>
            }
          />
        </Routes>
      </div>
    </BrowserRouter>
  );
};
